import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import ConsentDropzoneMessage from './ConsentDropzoneMessage';
import FileUpload from '../../../common/FileUpload/FileUpload';
function ConsentFileUpload(_ref) {
  var onFileChanged = _ref.onFileChanged,
    file = _ref.file,
    type = _ref.type;
  var _useState = useState({
      filesTooBig: [],
      filesWrongType: [],
      filesTooBigAndWrongType: []
    }),
    _useState2 = _slicedToArray(_useState, 2),
    rejectedFiles = _useState2[0],
    _setRejectedFiles = _useState2[1];
  return /*#__PURE__*/React.createElement(FileUpload, {
    rejectedFiles: rejectedFiles,
    setRejectedFiles: function setRejectedFiles(rejected) {
      _setRejectedFiles(rejected);
      onFileChanged(null);
    },
    setUploadedFiles: function setUploadedFiles(files) {
      return onFileChanged(files[0] || null);
    },
    uploadedFiles: file ? [file] : []
  }, /*#__PURE__*/React.createElement(ConsentDropzoneMessage, {
    type: type
  }));
}
ConsentFileUpload.propTypes = {
  file: PropTypes.object,
  onFileChanged: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired
};
ConsentFileUpload.defaultProps = {
  file: null
};
export default ConsentFileUpload;
//# sourceMappingURL=ConsentFileUpload.js.map